var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLa = function SvgIconLa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.809 6.782a12 12 0 0 0-10.81-6.783A12 12 0 0 0 1.19 6.782L12 7.825zM1.19 17.216A12 12 0 0 0 12 24a12 12 0 0 0 10.809-6.783l-10.81-1.043z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M22.81 6.782H1.19A11.95 11.95 0 0 0 0 11.999c0 1.87.428 3.64 1.19 5.217h21.62A11.95 11.95 0 0 0 24 12c0-1.87-.428-3.64-1.19-5.217"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 16.174a4.174 4.174 0 1 0 0-8.348 4.174 4.174 0 0 0 0 8.348"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconLa;